module.exports = __webpack_public_path__ + "static/img/copyright.8434f216.png";